import { getAuth,multiFactor ,PhoneMultiFactorGenerator,createUserWithEmailAndPassword,FacebookAuthProvider,GoogleAuthProvider ,signInWithPopup , RecaptchaVerifier, signInWithPhoneNumber, signInWithEmailAndPassword,signOut,PhoneAuthProvider } from "firebase/auth";
import React, { useEffect, useState } from 'react';
import { useNavigate,useLocation } from "react-router-dom";
import axios from "axios";
import { ErrorText, PrimaryText, PurpleText, SecondaryText } from "../components/mui/Typography";
import { PurpleButton } from "../components/mui/Buttons";
import { AutoCompleteInput, PhoneInput, TextInput } from "../components/mui/Inputs";
import '../styling/login.css'
import MuiPhoneNumber from 'material-ui-phone-number';
import { Autocomplete, Checkbox, FormControlLabel, IconButton, InputAdornment } from "@mui/material";
import { Error, Visibility, VisibilityOff } from "@mui/icons-material";
import VerifyPhoneNumber from "./verifyPhoneNumber";
import BackBar from "../components/BackBar";

export default function Register() {

    const baseURL = "https://us-central1-travel-fitness-pass.cloudfunctions.net/";

    const [nameText,setNameText] = useState("")
    const [surnameText,setSurnameText] = useState("")

    const [emailText,setEmailText] = useState("")
    const [genderText,setGenderText] = useState("")

    const [dobText,setDOBText] = useState("")
    const [countryText,setCountryText] = useState("")

    const [passwordText,setPasswordText] = useState("")
    const [referralText,setReferralText] = useState("")

    const [confirmPasswordText,setConfirmPasswordText] = useState("")
    const [phoneText,setPhoneText] = useState("")

    const [twoFactor,setTwoFactor] = useState(false)
    const [showVerify,setShowVerify] = useState(false)

    const [errorText,setErrorText] = useState("")

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);
    
    

    const location = useLocation();
    const navigate = useNavigate();


    const submitClicked = () => {

        checkFields()

    }

    const checkFields = () => {
        
        setErrorText("")

        
        if(passwordText !== confirmPasswordText){
            setErrorText("Error: Passwords don't match")
        }
        else{
            if(phoneText.length<5 && referralText !=="")
            {
                setErrorText("Error: You must enter phone number to verify referral code")
            }
            if(phoneText.length>5){checkNotDuplicateDB()}
            else{
                register()
            }

            
        }

    }

    const checkNotDuplicateDB = () => {

        axios.get(baseURL+'checksForNewAccount',{
            params:{
                phoneNumber:phoneText,
                referral:referralText
            }
        }).then((response) => {
            let resVar = response.data
            if(resVar.error){
                console.log(resVar.errorMessage)
                setErrorText("Error: " +resVar.errorMessage)
            }
            else{
                register()
            }
        })
    }

    const addAccountToDB = (uid) => {
        
        axios.post(baseURL+'createUserAccount',{
        
            uid:uid,

            firstName:nameText,
            surname:surnameText,
            email:emailText,
            gender:genderText,
            dob:dobText,
            country:countryText,
            referral:referralText,
            phone:phoneText,
            phoneCode:'+353',
            twoFactor:twoFactor,

            
        
        }).then((response) => {
            let resVar = response.data
            console.log("Response", resVar)
            
            if(twoFactor || referralText !== ""){
                signIn()
            }else{
                successfulAuth()
            }

        })
    }

    const signIn = () => {
        const auth = getAuth();

        signInWithEmailAndPassword(auth,  emailText, passwordText)
        .then((userCredential) => {
            // Signed in 
            setShowVerify(true)
        })
        .catch((error) => {
            // An error happened.
            const errorMessage = error.message;
            console.log("Sign in ERROR", errorMessage)
        });
    }

    
    const showLoginScreen = () => {
        navigate("../login", {   });
    }


    const register = () => {
        const auth = getAuth();
        console.log("REGISTER CLICKED")

        createUserWithEmailAndPassword(auth, emailText, passwordText)
        .then((userCredential) => {
            // Signed in 
            const user = userCredential.user;
            console.log("REG SUCCESS", user)
            // successfulAuth()
            // navigate("../verifyPhone", {   ,state:{phone:phoneText}});
            addAccountToDB(user.uid)
            
        })
        .catch((error) => {
            // An error happened.
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log(" REG ERROR ", errorMessage,error)

            if(errorCode === "auth/email-already-in-use"){setErrorText("Error: An account already exists with this email")}
        });
    }



    const successfulAuth = () => {
        if(location.state === null)
        {
            navigate("../", {   });
        }
        else{
            let gym = location.state.gym
            let pass = location.state.pass
            createBooking(gym,pass)
        }

    }

    const createBooking = (gym,pass) => {

        const auth = getAuth();
        const uid = auth.currentUser.uid;

        axios.get(baseURL+'createBooking',{
        
            params:{
                uid:uid,
                gym:gym.id,
                pass:pass.id
            }

        }).then((response) => {
            // setLoading(false)
            let resVar = response.data
            console.log("Booking Response", resVar)
            let bookingID = resVar.id
            navigate("../booking/"+bookingID, {   state:{gym:gym,pass:pass}});
        })
    }

    
    const genderOptions = ['Male','Female','Other']
    const countryOptions = [ "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas (the)", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia (Plurinational State of)", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory (the)", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Cayman Islands (the)", "Central African Republic (the)", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands (the)", "Colombia", "Comoros (the)", "Congo (the Democratic Republic of the)", "Congo (the)", "Cook Islands (the)", "Costa Rica", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Côte d'Ivoire", "Denmark", "Djibouti", "Dominica", "Dominican Republic (the)", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Falkland Islands (the) [Malvinas]", "Faroe Islands (the)", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories (the)", "Gabon", "Gambia (the)", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (the)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea (the Democratic People's Republic of)", "Korea (the Republic of)", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic (the)", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands (the)", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia (Federated States of)", "Moldova (the Republic of)", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands (the)", "New Caledonia", "New Zealand", "Nicaragua", "Niger (the)", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands (the)", "Norway", "Oman", "Pakistan", "Palau", "Palestine, State of", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines (the)", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Republic of North Macedonia", "Romania", "Russian Federation (the)", "Rwanda", "Réunion", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan (the)", "Suriname", "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands (the)", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates (the)", "United Kingdom of Great Britain and Northern Ireland (the)", "United States Minor Outlying Islands (the)", "United States of America (the)", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela (Bolivarian Republic of)", "Viet Nam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe", "Åland Islands" ];


    const phoneChange = (e) => {
        console.log("PONE CHANGED ", e)
    }

    const backClicked = () => {
        
    }

    
    const validateEmail = (email) => {
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      };



    return(
        <div className="registerScreen">
            <BackBar clicked={backClicked}/>

            
            <div className="fullScreen">
                <div className="container">
                    <div className="registerMainSection">

                        <div className="registerInputView">

                        <div className="loginHeaders">
                            <PrimaryText variant="h3">CREATE AN ACCOUNT</PrimaryText>
                            <SecondaryText variant="subtitle">Register to book and manage passes</SecondaryText>
                        </div>

                        <div className="loginRegisterSection">
                            <PrimaryText variant="subtitle">Already have an account?</PrimaryText>
                            <PurpleText className="loginRegisterButton" variant="subtitle" onClick={showLoginScreen}>Sign in</PurpleText>
                        </div>


                        <div className="registerInputsSection">
                            <div className="registerInputColumn">
                                <TextInput variant="outlined" label="First Name*"
                                value={nameText} onChange={(e) => setNameText(e.target.value)}/>

                                <TextInput variant="outlined" label="Surname*"
                                value={surnameText} onChange={(e) => setSurnameText(e.target.value)}/>

                                <TextInput type="date"  variant="outlined" label="Date of birth" required
                                value={dobText} onChange={(e) => setDOBText(e.target.value)}/>

                                <TextInput type="email" variant="outlined" label="Email*"
                                value={emailText} onChange={(e) => setEmailText(e.target.value)}
                                error={emailText.length>0 && !validateEmail(emailText)}
                                helperText={(emailText.length>0 && !validateEmail(emailText))?"Invalid email":""}
                                InputProps={{ // <-- This is where the toggle button is added.
                                    endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton>
                                            {(emailText.length>0 && !validateEmail(emailText)) && <Error className="inputErrorIcon"/>}
                                        </IconButton>
                                    </InputAdornment>
                                    )
                                }}
                                />

                                <PhoneInput defaultCountry={'ie'} variant="outlined" label="Phone number"
                                value ={phoneText} onChange={(e) => setPhoneText(e)}/>

                                <div className="twoFVOne"><FormControlLabel  control={<Checkbox checked={twoFactor} onChange ={(e) => setTwoFactor(e.target.checked)}/>} label="Use 2 factor verification" /></div>

                            </div>
                            <div className="registerInputColumn">
                                <Autocomplete disablePortal options={genderOptions} renderInput={(params)=><TextInput {...params} variant="outlined" label="Gender" value={genderText} />} onChange={(e) => setGenderText(e.target.textContent)}/>
                                
                                <Autocomplete disablePortal options={countryOptions} renderInput={(params)=><TextInput {...params} variant="outlined" label="Country" value={countryText} />} onChange={(e) => setCountryText(e.target.textContent)}/>

                                <TextInput type={showPassword ? "text" : "password"}  variant="outlined" label="Password*"
                                    error = {passwordText.length<6 && passwordText.length>0}
                                    helperText = {passwordText.length<6 && passwordText.length>0?"Password must be a minimum of 6 characters long":""}
                                    InputProps={{ // <-- This is where the toggle button is added.
                                        endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                        )
                                    }}
                                    value={passwordText} onChange={(e) => setPasswordText(e.target.value)}
                                />

                                <TextInput type={showPassword ? "text" : "password"} variant="outlined" label="Confirm password*"
                                    error = {passwordText!==confirmPasswordText  && confirmPasswordText.length>0}
                                    helperText = {passwordText!==confirmPasswordText  && confirmPasswordText.length>0?"Passwords do not match":""}
                                    InputProps={{ // <-- This is where the toggle button is added.
                                        endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                        )
                                    }}
                                    value={confirmPasswordText} onChange={(e) => setConfirmPasswordText(e.target.value)}
                                />

                                <TextInput variant="outlined" label="Referral code"value={referralText} onChange={(e) => setReferralText(e.target.value)}/>

                                <div className="twoFVTwo"><FormControlLabel  control={<Checkbox checked={twoFactor} onChange ={(e) => setTwoFactor(e.target.checked)}/>} label="Use 2 factor verification" /></div>
                            </div>
                            
                        </div>

                        <div className="loginSubmitSection">
                            <FormControlLabel control={<Checkbox/>} label={<span>I hereby agree to the <span className="registerTermsLink">Terms & Conditions</span> and <span className="registerTermsLink">Privacy Policy</span></span>} />

                            <PurpleButton variant="contained" size="medium" onClick={checkFields}
                            disabled={nameText==="" || surnameText===""  || genderText===""  || dobText==="" ||  emailText==="" || !validateEmail(emailText) || passwordText.length<6 || confirmPasswordText.length<6 || passwordText !== confirmPasswordText}>
                                REGISTER</PurpleButton>

                        </div>

                        <ErrorText variant="body">{errorText}</ErrorText>

                        </div>


                        {showVerify && <div className="phoneVerifyScreen">
                                <VerifyPhoneNumber phoneNumber={phoneText} referralCode={referralText} twoFactor={twoFactor}/>
                        </div>}

                    </div>
                </div>
            </div>

            

        </div>

        
    )
}